import React, { useEffect, useState } from 'react';

// redux
import { useSelector } from "react-redux";
import { selectActiveTasksNum, selectArrivalsTasksNum, selectCompletedTasksNum, selectDashboardAvailableEmployeeNum, selectDeparturesTasksNum, selectTotalTasksNum } from '_redux/slices/timeline/timeline-dashboard';

// tremor
import { Card, Subtitle, Metric, Title as TremorTitle } from '@tremor/react';

// bootstrap
import { Col, Row } from 'react-bootstrap';

// custom components
import { CategoryBar, CustomMetric, CustomSubtitle } from '_atoms';
import { DashboardLineGraph } from '_organisms';

// styling
import { Colors } from '_styles';

const OperationalOverview = () => {
    // for development
    const borderWidth = 0;
    //#region redux

    const activeTasksNum = useSelector(selectActiveTasksNum);                                       // active tasks number
    const availableEmployeeNum = useSelector(selectDashboardAvailableEmployeeNum);                  // available employees number
    const totalTasksNum = useSelector(selectTotalTasksNum);                                       // total tasks number
    const completedTasksNum = useSelector(selectCompletedTasksNum);                               // completed tasks number
    const departuresTasksNum = useSelector(selectDeparturesTasksNum);                             // departures tasks number
    const arrivalsTasksNum = useSelector(selectArrivalsTasksNum);                                 // arrivals tasks number
    //#endregion

    //#region local states
    const [totalToCompletedPer, setTotalToCompletedPer] = useState(0);                         // percentage between total and completed tasks
    //#endregion

    //#region useEffect
    // get the percentage between completed and total tasks
    useEffect(() => {
        if (completedTasksNum) {
            setTotalToCompletedPer((completedTasksNum / totalTasksNum) * 100)
        }
    }, [totalTasksNum, completedTasksNum]);
    //#endregion


    return (
        <Row>

            {/* title */}
            <Row>
                <TremorTitle>{'Operation Overview'}</TremorTitle><Subtitle>{'View an overview of your operation'}</Subtitle>
            </Row>


            <Row style={{
                borderStyle: 'solid', borderWidth: borderWidth,
                display: 'flex',
                flex: 1
            }}>

                {/* active tasks + available cca */}
                <Col xs={12} md={6} lg={3} style={{ borderStyle: 'solid', borderWidth: borderWidth }}>
                    {/* active tasks + available cca */}
                    <div style={{ borderStyle: 'solid', borderWidth: borderWidth, flex: 1 }}>

                        {/* active tasks */}
                        <div style={{ borderStyle: 'solid', borderWidth: borderWidth, padding: 12 }}>
                            <Card>
                                <Subtitle>Active Tasks</Subtitle>
                                <Metric>{activeTasksNum}</Metric>
                            </Card>
                        </div>
                        <div style={{ borderStyle: 'solid', borderWidth: borderWidth, padding: 12 }}>
                            <Card>
                                <Subtitle>Available CCA</Subtitle>
                                <Metric>{availableEmployeeNum}</Metric>
                            </Card>
                        </div>
                    </div>
                </Col>

                {/* total bookings */}
                <Col xs={12} md={6} lg={3} style={{ borderStyle: 'solid', borderWidth: borderWidth }}>
                    {/* total bookings */}
                    <div style={{ borderStyle: 'solid', borderWidth: borderWidth, padding: 12, flex: 2 }}>
                        <Card>
                            <Subtitle>Total Bookings</Subtitle>
                            <Metric>{totalTasksNum}</Metric>

                            <div className='mt-2'>
                                <Subtitle>Completed Tasks</Subtitle>
                            </div>

                            <div className='mt-2'>
                                <div style={{
                                    height: '11px', borderRadius: '10px', transition: "width 0.3s ease",
                                    background: `linear-gradient(to right, #1de476 ${totalToCompletedPer}%, #a6b3c4 ${totalToCompletedPer}%)`
                                }} />

                            </div>
                            <div className='mt-2' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p style={{ fontSize: 16, color: Colors.PRM_LIGHT_BLUE }}>{`${Math.round(totalToCompletedPer)?.toLocaleString() ?? 0}%`}</p>
                                <p style={{ fontSize: 16, color: Colors.PRM_GRAY }}>{`${completedTasksNum ?? 0} of ${totalTasksNum ?? 0}`}</p>
                            </div>
                            <div className='mt-2'>
                                <CategoryBar
                                    a={departuresTasksNum}
                                    b={arrivalsTasksNum}
                                    labelA={'Departures'}
                                    labelB={'Arrivals'}
                                />
                            </div>

                        </Card>
                    </div>




                </Col>

                {/* line graph */}
                <Col xs={12} md={12} lg={6} style={{ borderStyle: 'solid', borderWidth: borderWidth }}>
                    <DashboardLineGraph />
                </Col>

            </Row>
        </Row>
    );
};

export default OperationalOverview;
